module.exports = __webpack_public_path__ + "static/img/conveyor-belt-mk-5_256.3e8d9e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conveyor-belt-mk-5_256.png
// module id = Fh/K
// module chunks = 0